import React from 'react'
import InteractiveButton from '../InteractiveButton/InteractiveButton';

export type ButtonGroupAction = {
  id: string,
  text: string,
  onClick: (data: { event?: React.MouseEvent, action?: ButtonGroupAction }) => void;
  type: 'a' | 'button';
  is_active?: boolean;
};

type ComponentProps = {
  actions: ButtonGroupAction[];
  className?: string;
}

const ButtonGroups: React.FC<ComponentProps> = ({ actions, className = '' }) => {
  const CLASS_NAME = new Map([
    [true, 'bg-primary font-medium border border-burnt-orang hover:bg-[#ff9146] active:bg-[ff6700] bg-primary text-white'],
    [false, 'bg-primary font-medium border border-burnt-orang hover:bg-[#ff9146] active:bg-[ff6700] bg-white text-black'],
    [undefined, '']
  ]);

  return (
    <div className={`c-button-group grid grid-flow-col auto-cols-fr gird gap-x-3 ${className}`}>
      {actions.map((action) => (
        <InteractiveButton
          key={action.id}
          onClick={(event) => action.onClick({ event, action })}
          customType={CLASS_NAME.get(action?.is_active)}
          style={{ padding: '8px' }}
          as={action.type}
        >
          {action.text}
        </InteractiveButton>
      ))}
    </div>
  )
};

export default ButtonGroups;